export enum PrintProductTemplateOrderField {
	Id = 'Id',
	Title = 'Title',
	Sku = 'Sku',
}
